import { Injectable } from '@angular/core';
import { SvgBrokenIcon } from './svg-broken-icon'

@Injectable({
  providedIn: 'root'
})

export class SvgIconService {
  public svgIcon: SvgIconType = {};
  private iconsLoaded = false;
  private loadingPromise: Promise<void> | null = null;

  constructor() {
    // Start loading icons immediately
    this.ensureIconsLoaded();
  }

  async ensureIconsLoaded(): Promise<void> {
    if (this.iconsLoaded) {
      return;
    }

    if (!this.loadingPromise) {
      this.loadingPromise = this.loadIcons();
    }

    return this.loadingPromise;
  }

  private async loadIcons(): Promise<void> {
    if (!this.iconsLoaded) {
      try {
        const { SvgIcon } = await import('@project/core/models/svg-icons');
        this.svgIcon = SvgIcon;
        this.iconsLoaded = true;
      } catch (error) {
        console.error('Failed to load SVG icons:', error);
        throw error;
      }
    }
  }

  hasIcon(iconName: string) {
    return this.svgIcon.hasOwnProperty(iconName);
  }

  getIcon(iconName: string) {
    return this.svgIcon[iconName] || this.getDefaultIcon();
  }

  getDefaultIcon() {
    return SvgBrokenIcon;
  }
}

export type SvgIconType = {
  [key: string]: string;
};
